<div class="bg-white">
  <div class="container d-flex justify-content-between align-items-center py-3">
    <div>
      <img src="assets/img/logo.png" alt="Home Image" />
    </div>
    <div>
      <a

        href="https://api.whatsapp.com/send/?phone=16468796854&text=Hi,I want to book a demo for my business&type=phone_number"
        target="_blank"
        >
        <button class="btn bg-secondary text-primary signin mx-2">
          Book a Demo
        </button>
      </a>
      <button
        routerLink="/signin"
        class="btn bg-secondary text-primary signin mx-2"
        >
        Sign In
      </button>
      <button routerLink="/signup" class="btn text-white bg-primary signin">
        Sign Up
      </button>
    </div>
  </div>

  <div class="container">
    <div class="bg-light p-3 b-radius-10">
      <h1 class="text-center text-primary"><b> Welcome to dadyin </b></h1>
      <!-- <div class="w-100 row">
      <div class="col-md-3 col-12">
        <div class="mx-1 w-100">
          <dadyin-searchable-select
            class="custom-home"
            placeholder="Select Industry Type *"
            [control]="industryTypeId"
            [fullItems]="apiService.allIndustryTypes"
          ></dadyin-searchable-select>
        </div>
      </div>
      <div class="col-md-9 my-2 my-md-0 col-12">
        <div
          class="w-100 d-flex align-items-center b-radius bg-white b-light mx-1"
          >
          <mat-icon
            class="mx-1"
            style="color: grey; font-size: 20px; height: 20px; width: 20px"
            >search</mat-icon
            >
            <input
              type="text"
              style="font-size: 12px"
              class="form-control b-none"
              placeholder="Enter Company Name"
              />
              <button
                style="height: 30px; align-items: center; display: flex"
                class="btn bg-secondary text-primary b-radius"
                >
                Search
              </button>
            </div>
          </div>
        </div> -->
      </div>

      <div class="row my-2 b-radius-10">
        <div class="col-md-6 col-12">
          <div class="bg-light container pt-4 mt-1">
            <div class="row">
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-8 col-md-12">
                    <h2 class="text-primary"><b>Compare Price with us</b></h2>
                    <h4 class="text-muted">
                      Upload your PO, Invoices and compare your buying Price with
                      the price we offer
                    </h4>
                  </div>
                  <div class="col-4 col-md-12 p-0">
                    <div class="d-flex h-100 align-items-center">
                      <img
                        width="100%"
                        src="assets/img/home/compare.png"
                        alt="Home Image"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12 pb-5">
                  <div
                    (drop)="fileSelected($event, 'drop', fileinp1)"
                    (dragover)="onDragOver($event)"
                    (click)="fileinp1.click()"
                    style="cursor: pointer; text-align: center"
                    class="upload-box dashed-border text-muted d-flex flex-column"
                    >
                    <div class="w-100 font-size-14">
                      @if (!poFile) {
                        <div>
                          Drag & drop a file, <strong>click to browse</strong>, or
                          <strong>paste</strong> it here.
                        </div>
                      }

                      @if (poFile) {
                        <div class="text-primary">
                          <span> {{ poFile?.name }} </span>
                          <i class="material-icon mx-1" (click)="poFile = null"
                            >delete</i
                            >
                          </div>
                        }
                      </div>

                      <input
                        (paste)="onPaste($event, fileinp1)"
                        (click)="$event.stopPropagation()"
                        class="w-100"
                        />
                      </div>

                      <input
                        (change)="fileSelected($event, 'normal', fileinp1)"
                        type="file"
                        style="display: none !important"
                        #fileinp1
                        accept=".pdf,.png,.jpeg,.jpg,.webp"
                        />
                        <div class="w-100 mt-2">
                          <dadyin-button
                            class="w-100"
                            (clicked)="generatePoFromPdf(fileinp1)"
                            [isDisabled]="!poFile"
                            [theme]="'primary'"
                            [label]="'Compare Price'"
                            >
                          </dadyin-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-12">
                  <div class="bg-light container h-100 pt-4 mt-1 overflow-hidden">
                    <div class="row">
                      <div class="row">
                        <div class="col-8 col-md-12">
                          <h2 class="text-primary">
                            <b>Experience the power of DadyIn SaaS platform</b>
                          </h2>
                          <h4 class="text-muted pb-3">
                            Specially designed to efficiently manage and grow your
                            business operations.
                          </h4>
                        </div>
                        <div class="col-4 col-md-12 p-0 d-md-none d-block">
                          <div class="d-flex h-100 align-items-center">
                            <img
                              width="100%"
                              src="assets/img/home/saas.png"
                              alt="Home Image"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-md-8 font-size-14">
                          <div
                            class="d-flex align-items-center justify-content-between"
                            style="column-gap: 5px"
                            >
                            <div
                              class="bg-white b-light text-primary w-50 text-center p-2 b-radius-10"
                              style="cursor: pointer"
                  (click)="
                    router.navigate(['/signup'], {
                      queryParams: { businessLines: 'MANUFACTURER' }
                    })
                  "
                              >
                              Manufacturers
                            </div>
                            <div
                              class="bg-white b-light text-primary w-50 text-center p-2 b-radius-10"
                              style="cursor: pointer"
                  (click)="
                    router.navigate(['/signup'], {
                      queryParams: { businessLines: 'IMPORTER' }
                    })
                  "
                              >
                              Importer/Exporters
                            </div>
                          </div>
                          <div
                            class="d-flex align-items-center justify-content-between py-2"
                            style="column-gap: 5px"
                            >
                            <div
                              class="bg-white b-light text-primary w-50 text-center p-2 b-radius-10"
                              style="cursor: pointer"
                  (click)="
                    router.navigate(['/signup'], {
                      queryParams: { businessLines: 'DISTRIBUTOR' }
                    })
                  "
                              >
                              Distributors
                            </div>
                            <div
                              class="bg-white b-light text-primary w-50 text-center p-2 b-radius-10"
                              style="cursor: pointer"
                  (click)="
                    router.navigate(['/signup'], {
                      queryParams: { businessLines: 'RETAILER' }
                    })
                  "
                              >
                              Retailers
                            </div>
                          </div>
                        </div>
                        <div class="col-4 d-none d-md-block">
                          <div class="d-flex align-items-center">
                            <img src="assets/img/home/saas.png" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bg-light b-radius-10 trending pb-3">
                <div class="container">
                  <div class="text-start text-primary">
                    <b class="trending-text"> Trending this month </b>
                  </div>
                  <div
                    class="mt-4 w-100 d-flex align-items-center b-radius bg-white b-light mx-1"
                    >
                    <mat-icon
                      class="mx-1"
                      style="color: grey; font-size: 20px; height: 20px; width: 20px"
                      >search</mat-icon
                      >
                      <input
                        (input)="searchProduct($event)"
                        type="text"
                        style="font-size: 14px"
                        class="form-control b-none"
                        placeholder="Search here"
                        />
                        <button
                          style="height: 30px; align-items: center; display: flex"
                          class="btn bg-secondary text-primary b-radius"
                          >
                          Search
                        </button>
                      </div>
                      <div
                        class="d-flex justify-content-start my-3"
                        style="column-gap: 10px; overflow: auto; white-space: nowrap"
                        >
                        <button class="btn fw-bold bg-secondary text-primary b-radius">
                          Top Rated
                        </button>
                        <!-- <button class="btn bg-white b-light text-primary b-radius">
                        Thanksgiving
                      </button>
                      <button class="btn bg-white b-light text-primary b-radius">
                        Halloween
                      </button>
                      <button class="btn bg-white b-light text-primary b-radius">
                        Christmas
                      </button> -->
                    </div>

                    <div class="my-3">
                      <swiper-container #swiperLanding init="false">
                        @for (product of productsList; track product; let j = $index) {
                          <swiper-slide>
                            <div class="product-card shadow-sm p-1 my-3 bg-white b-radius-10">
                              <img
                                class="b-radius-10"
                                width="100%"
                                [src]="imgSrc + product?.productImageFileNames[0]"
                                alt=""
                                />
                                <div class="my-2 px-2">
                                  <p
                  style="
                    height: 45px;
                    font-size: 14px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                                    >
                                    <b> {{ product?.description }} </b>
                                  </p>
                                  <div
                                    class="d-flex justify-content-between align-items-center mb-1"
                                    >
                                    <div class="text-primary">
                                      <b>
                                        {{ product?.skuThirdTier?.userConversionUom }}
                                        {{ product?.skuThirdTier?.attributeValue }}/SKU</b
                                        >
                                      </div>
                                      <div>
                                        <i class="material-icon star-icon-size font-size-14"
                                          >star</i
                                          >
                                          <b> 5 </b>
                                          <span class="text-muted"> | 204 </span>
                                        </div>
                                      </div>
                                      <div class="w-100">
                                        <button
                                          (click)="orderNow(product)"
                                          class="btn b-round bg-secondary text-primary w-100 font-size-14"
                                          >
                                          Order Now
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </swiper-slide>
                              }
                            </swiper-container>
                          </div>
                          <div class="d-flex algn-items-center justify-content-center">
                            <button
          (click)="
            navigate(
              getExploreMoreUrl('pharmacy')
            )
          "
                              class="btn bg-primary text-white b-radius-10"
                              >
                              Explore More
                            </button>
                          </div>

                          <div class="bg-secondary font-size-14 b-light p-2 my-5 b-radius-10">
                            <i class="material-icon">info</i>
                            <span class="text-dark">
                              All the prices displayed above are retail prices. For bulk pricing,
                              group ordering discounts, and customization options, log in to DadyIn
                              and unlock exclusive features tailored to your business.
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="container">
                        <div class="py-5 b-radius-10">
                          <h4 class="text-center text-primary"><b>Ordering fom dadyin</b></h4>
                          <h1 class="text-center text-dark"><b>Bulk ordering made simple</b></h1>

                          <h3 class="text-muted text-center">
                            We offer flexible ordering options tailored to your needs, including
                            pallet orders, truckload orders, and container orders.
                          </h3>

                          <div class="row">
                            <div class="col-12 col-md-4 p-4">
                              <div class="bg-light d-flex align-items-center">
                                <img
                                  style="margin-left: -35px; margin-bottom: -35px"
                                  width="30%"
                                  src="assets/img/home/palletorder.png"
                                  alt=""
                                  />
                                  <h3 class="w-100 text-center tex-dark m-0"><b>Pallet Order</b></h3>
                                </div>
                              </div>
                              <div class="col-12 col-md-4 p-4">
                                <div class="bg-light d-flex align-items-center">
                                  <img
                                    style="margin-left: -35px; margin-bottom: -35px"
                                    width="30%"
                                    src="assets/img/home/truckorder.png"
                                    alt=""
                                    />
                                    <h3 class="w-100 text-center tex-dark m-0"><b>Truck Order</b></h3>
                                  </div>
                                </div>
                                <div class="col-12 col-md-4 p-4">
                                  <div class="bg-light d-flex align-items-center">
                                    <img
                                      style="margin-left: -35px; margin-bottom: -35px"
                                      width="30%"
                                      src="assets/img/home/containerorder.png"
                                      alt=""
                                      />
                                      <h3 class="w-100 text-center tex-dark m-0">
                                        <b>Container Order</b>
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="py-5 b-radius-10">
                                <h4 class="text-center text-primary"><b>Quick Checkout</b></h4>
                                <h1 class="text-center text-dark"><b>Home of Products</b></h1>

                                <h3 class="text-muted text-center">
                                  Offering a wide range of products across industries, available for bulk
                                  orders
                                </h3>

                                <swiper-container #swiperLanding2 init="false">
                                  @for (product of productsList; track product; let j = $index) {
                                    <swiper-slide>
                                      <div
                                        class="product-card b-light shadow-sm p-2 my-3 bg-white b-radius-10"
                                        >
                                        <img
                                          [src]="imgSrc + product?.productImageFileNames[0]"
                                          width="100%"
                                          alt=""
                                          />
                                        </div>
                                      </swiper-slide>
                                    }
                                  </swiper-container>

                                  <div class="d-flex algn-items-center justify-content-center">
                                    <button
          (click)="
            navigate(
              getExploreMoreUrl('pharmacy')
            )
          "
                                      class="btn bg-primary text-white b-radius-10"
                                      >
                                      Explore More
                                    </button>
                                  </div>
                                </div>

                                <div class="py-5 b-radius-10">
                                  <h3 class="text-center text-primary"><b>Designed for</b></h3>
                                  <h1 class="text-center text-dark"><b>Made for all business types</b></h1>

                                  <h3 class="text-muted text-center">
                                    Easily manage your business with the powerful
                                  </h3>

                                  <div class="row">
                                    <div class="col-md-3 col-12 my-2">
                                      <div class="bg-light" style="height: 100%; border-radius: 10px">
                                        <img width="100%" src="assets/img/home/manufacturers.png" alt="" />
                                        <h2 class="text-center my-2 text-dark"><b> Manufacturers </b></h2>
                                        <div class="p-1">
                                          <ul>
                                            <li>
                                              <b>Process Simplification:</b> Manage intricate manufacturing
                                              workflows seamlessly.
                                            </li>
                                            <li>
                                              <b>Audience Expansion:</b> Showcase products to a larger and
                                              more diverse customer base.
                                            </li>
                                            <li>
                                              <b>Quick Checkout Listing:</b> Ensure products are easily
                                              accessible for retailers and distributors.
                                            </li>
                                            <li>
                                              <b>Advanced Order management:</b> Leverage tools for
                                              comprehensive oversight of orders.
                                            </li>
                                            <li>
                                              <b>Streamlined Bulk Handling:</b> Optimize container-based
                                              transactions with efficient checkout processes.
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3 col-12 my-2">
                                      <div class="bg-light p-2" style="height: 100%; border-radius: 10px">
                                        <img width="100%" src="assets/img/home/importer.png" alt="" />
                                        <h2 class="text-center my-2 text-dark"><b>Importer/Exporter</b></h2>
                                        <div class="p-1">
                                          <ul>
                                            <li>
                                              <b>Container management:</b> Streamline container handling on
                                              a unified platform.
                                            </li>
                                            <li>
                                              <b>Tracking Tools:</b> Monitor containers, unloading, and
                                              customer access.
                                            </li>
                                            <li>
                                              <b>Order management:</b> Use advanced tools to oversee and
                                              fulfill orders effectively.
                                            </li>
                                            <li>
                                              <b>Network Expansion:</b> Connect with a wide range of
                                              distributors and wholesalers.
                                            </li>
                                            <li>
                                              <b>Effortless Container Checkout:</b> Simplify bulk shipment
                                              handling.
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3 col-12 my-2">
                                      <div class="bg-light p-2" style="height: 100%; border-radius: 10px">
                                        <img width="100%" src="assets/img/home/distributors.png" alt="" />
                                        <h2 class="text-center my-2 text-dark"><b>Distributors</b></h2>
                                        <div class="p-1">
                                          <ul>
                                            <li>
                                              <b>Open Market Access:</b> Reach a broad audience of
                                              distributors and retailers.
                                            </li>
                                            <li>
                                              <b>B2B Selling Opportunities:</b> Expand sales to a diverse
                                              business clientele.
                                            </li>
                                            <li>
                                              <b>Vendor Access:</b> Connect with manufacturers and
                                              importers.
                                            </li>
                                            <li>
                                              <b>Comprehensive Order management:</b> Utilize tools for RFQs,
                                              quotations, sales orders, purchase orders, bills, and
                                              invoices.
                                            </li>
                                            <li>
                                              <b>Palletized Sales:</b> Optimize operations by focusing on
                                              pallet-based transactions.
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-3 col-12 my-2">
                                      <div class="bg-light p-2" style="height: 100%; border-radius: 10px">
                                        <img width="100%" src="assets/img/home/retailers.png" alt="" />
                                        <h2 class="text-center my-2 text-dark"><b>Retailer</b></h2>
                                        <div class="p-1">
                                          <ul>
                                            <li>
                                              <b>Diverse Catalog Access:</b> Browse and choose from a wide
                                              variety of products.
                                            </li>
                                            <li>
                                              <b>Quick Checkout:</b> Simplified purchasing process for
                                              efficiency.
                                            </li>
                                            <li>
                                              <b>Price Comparison:</b> Compare prices across vendors,
                                              including those they add themselves.
                                            </li>
                                            <li>
                                              <b>Vendor Connectivity:</b> Establish direct connections with
                                              multiple vendors.
                                            </li>
                                            <li>
                                              <b>Group Ordering:</b> Collaborate with peers for bulk pricing
                                              advantages.
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
